var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "carousel_arrow",
      class: [
        { next: _vm.direction === "next", prev: _vm.direction === "prev" },
        _vm.theme,
      ],
    },
    [_c("chevron-right")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }